import { GraduationCap, Hammer, Users } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import womenCodeImage from '@/assets/women-code.jpg';
import womenCommunityImage from '@/assets/women-community.jpg';

const VALUES = [
  {
    icon: GraduationCap,
    title: 'Learn',
    description:
      'Zero-to-one workshops on Bitcoin, Lightning, and Nostr. Come curious, leave dangerous.',
  },
  {
    icon: Hammer,
    title: 'Build',
    description:
      'Two days of hacking with mentors from the Bitcoin and Nostr ecosystems by your side.',
  },
  {
    icon: Users,
    title: 'Connect',
    description:
      'Join a sisterhood of Kenyan women builders, designers, and dreamers shaping freedom tech.',
  },
];

export function About() {
  return (
    <section id="about" className="scroll-mt-20 py-20 sm:py-28">
      <div className="container grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        {/* Image collage */}
        <div className="relative mx-auto w-full max-w-lg lg:mx-0">
          <div className="overflow-hidden rounded-2xl shadow-xl shadow-accent/20 ring-1 ring-border">
            <img
              src={womenCodeImage}
              alt="Two women pair-programming on a laptop, reviewing code together"
              className="aspect-[4/3] w-full object-cover transition-transform duration-500 hover:scale-105"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 hidden w-52 overflow-hidden rounded-2xl border-4 border-background shadow-lg sm:block lg:-right-8">
            <img
              src={womenCommunityImage}
              alt="Women collaborating on laptops at a table"
              className="aspect-square w-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -left-3 -top-3 -z-10 size-full rounded-2xl bg-primary/20 lg:-left-6 lg:-top-6" />
        </div>

        {/* Copy */}
        <div className="space-y-6">
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-primary">
            Why SheSats
          </p>
          <h2 className="font-display text-4xl font-semibold leading-tight tracking-tight text-balance sm:text-5xl">
            Nairobi runs on hustle.{' '}
            <span className="text-accent dark:text-primary">It deserves money built by its women.</span>
          </h2>
          <p className="text-lg leading-relaxed text-muted-foreground">
            From M-Pesa to mobile banking, Kenya has always been ahead of the money
            curve. The next curve is Bitcoin and open protocols like Nostr — and
            women deserve a front-row seat in building it.
          </p>
          <p className="text-lg leading-relaxed text-muted-foreground">
            SheSats Nairobi is a free, beginner-friendly hackathon where women of
            every background — coders, designers, writers, entrepreneurs — team up
            for a weekend to learn, experiment, and launch real projects on open
            money networks.
          </p>
        </div>
      </div>

      {/* Value cards */}
      <div className="container mt-20 grid gap-6 sm:grid-cols-3">
        {VALUES.map((value) => (
          <Card
            key={value.title}
            className="group border-border/70 transition-all duration-300 hover:-translate-y-1 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/10"
          >
            <CardContent className="flex flex-col gap-4 p-6">
              <span className="grid size-12 place-items-center rounded-xl bg-primary/15 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                <value.icon className="size-6" aria-hidden />
              </span>
              <h3 className="font-display text-2xl font-semibold">{value.title}</h3>
              <p className="leading-relaxed text-muted-foreground">{value.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
